
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:inline-flex;
}

.dropdown{
  display:flex;
}

.dropdown__trigger{
  position:relative;
}

.dropdown__panel{
}

outline-button .btn{
    padding:var(--outline-btn-padding) !important;
  }

outline-button .icon__trigger{
    display:flex;
    place-items:center;
    margin-left:var(--spacing-4);
  }
`;